import { render, staticRenderFns } from "./AllCompanyIncorporationSubmissions.vue?vue&type=template&id=2846aa42&scoped=true&"
import script from "./AllCompanyIncorporationSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllCompanyIncorporationSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllCompanyIncorporationSubmissions.vue?vue&type=style&index=0&id=2846aa42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2846aa42",
  null
  
)

export default component.exports